module.exports = __webpack_public_path__ + "static/media/banner-english-recruiting@1x.33d5addb.png";